export default __webpack_public_path__ + "public/assets/images/44f585d4dd53504a4b039c70d461bd0a.png";